import React from 'react';
import { getWaveHeightClass, getWaveIndicator } from '../../../utils/helpers';

const WaveHeightRowDaily = ({dayData, units}) => {

    

    return (
        <tr className="hover:bg-custom-darker/50 transition-colors">
            <td className="pl-2 pb-1 pt-2 text-xs text-custom-light-grey ">
                <div className="inline-flex items-center gap-2 font-medium">
                    <div>
                        Wave&nbsp;H<br />
                        {units && <span className="text-custom-light-grey/70">({units})</span>}
                    </div>
                </div>
            </td>
            {dayData.map((value, index) => {

                const height = dayData?.[index];
                const heightClass = getWaveHeightClass(height);
                const waveIndicator = getWaveIndicator(height);
                return (
                    <td key={index} className="pl-2 pb-1 pt-2 text-center" valign='bottom'>
                        <div className="inline-flex flex-col items-center gap-1">
                            <div className="flex justify-center">{waveIndicator}</div>
                            <div className={`inline-block min-w-[30px] text-center text-sm font-medium ${heightClass}`}>
                                {height?.toFixed(1)}
                            </div>
                        </div>
                    </td>
                );
            })}
        </tr>
    )
}

export default WaveHeightRowDaily;